import styled from 'styled-components';

export const CardContainer = styled.button`
  position: relative;
  flex: 1;
  margin: 15px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 5px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-blend-mode: darken;
  width: 95%;
  max-width: 500px;

  ${(props) =>
    props.backgroundColor
      ? `background-color: ${props.backgroundColor}`
      : 'background-color: rgb(10, 10, 10, 0.5)'};
  ${(props) => props.size?.height && `height: ${props.size.height}px`};
  ${(props) => props.size?.minWidth && `min-width: ${props.size.minWidth}px`};
  ${(props) =>
    props.backgroundImage && `background-image: url(${props.backgroundImage})`};

  ${(props) => !props.onClick && `cursor: default`};

  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  }
`;
